import React, { useState } from 'react';
import { isUserLoggedIn } from '../../shared/utils/function';
import { 
  showSignInRequired, 
  customConfirm, 
  confirmUnfollow,
  showFollowSuccess,
  showUnfollowSuccess,
  showError 
} from '../../shared/utils/swalHandler';
import { useNavigation } from '../../shared/utils/useNavigation';
import { DEFAULT_USER_AVATAR } from '../../shared/constants/common';
import { followPPV, unfollowPPV } from '../../shared/actions/followAction';
import './button.css';

const FollowPPVCreatorButton = ({ 
  creator, 
  onFollowSuccess = null, 
  onUnfollowSuccess = null,
   children 
}) => {
  const navigate = useNavigation();
  const isLoggedIn = isUserLoggedIn();
  const [followLoading, setFollowLoading] = useState(false);

  const handleClick = async (event) => {
    if (followLoading) {
      event?.preventDefault();
      return;
    }

    if (!isLoggedIn) {
      const shouldSignIn = await showSignInRequired('follow');
      if (shouldSignIn) {
        navigate.toLogin();
      }
      return;
    }

    // Check if user is already following
    if (creator.isFollowing) {
      handleUnfollow();
    } else {
      handleFollow();
    }
  };

  const handleFollow = async () => {
    // Show confirmation dialog with creator's profile picture
    const profilePicture = creator.avatar || creator.profile_picture || DEFAULT_USER_AVATAR;
    const username = creator.username.replace('@', '');
    
    // const confirmed = await customConfirm(
    //   '',
    //   `Follow @${username}?`,
    //   'Follow',
    //   'Cancel',
    //   { imageUrl: profilePicture }
    // );
    
    // if (confirmed) {
    //   followCreator(creator._id, username);
    // }
    followCreator(creator._id, username);
  };

  const handleUnfollow = async () => {
    // Show unfollow confirmation dialog with creator's profile picture
    const profilePicture = creator.avatar || creator.profile_picture || DEFAULT_USER_AVATAR;
    const username = creator.username.replace('@', '');
    
    const confirmed = await confirmUnfollow(
      `@${username}`,
      { imageUrl: profilePicture }
    );
    
    if (confirmed) {
      unfollowCreator(creator._id, username);
    }
  };

  const followCreator = async (creatorId, username) => {
    setFollowLoading(true);
    try {
      const response = await followPPV(creatorId);
      
      if (response.success) {
        // await showFollowSuccess(username);
        // Notify parent component about successful follow
        if (onFollowSuccess) {
          onFollowSuccess(creatorId);
        }
      } else {
        await showError("Error", response.error || "Something went wrong. Please try again.");
      }
    } catch (error) {
      await showError("Error", "Something went wrong. Please try again.");
    } finally {
      setFollowLoading(false);
    }
  };

  const unfollowCreator = async (creatorId, username) => {
    setFollowLoading(true);
    try {
      const response = await unfollowPPV(creatorId);
      
      if (response.success) {
        // await showUnfollowSuccess(username);
        // Notify parent component about successful unfollow
        if (onUnfollowSuccess) {
          onUnfollowSuccess(creatorId);
        }
      } else {
        await showError("Error", response.error || "Something went wrong. Please try again.");
      }
    } catch (error) {
      await showError("Error", "Something went wrong. Please try again.");
    } finally {
      setFollowLoading(false);
    }
  };

  const buttonLabel = children.props.children;

  // Clone the children element and add onClick handler
  return React.cloneElement(children, {
    onClick: handleClick,
    disabled: followLoading || children.props.disabled,
    children: (
      <>
        {followLoading && (
          <span
            className="spinner-border spinner-border-sm btn-loading-spinner mr-1"
            role="status"
            aria-hidden="true"
          />
        )}
        {buttonLabel}
      </>
    ),
  });
};

export default FollowPPVCreatorButton;

